<template>
   <div class="content-container">
      <SpinnerOverlay v-show="dataLoading" />

      <div v-if="dataLoading || pageLoading" class="rdig-click-blocker"></div>

      <div class="content d-flex flex-column">
         <AppHeader :dataLoading="dataLoading" />
         <BreadCrumbs />
         <AlertMessages class="layout-alerts" />
         <transition-group name="fade-fast" mode="out-in">
            <PageLoad v-if="pageLoading" key="tg-page-load" />
            <div v-show="!pageLoading" key="tg-page-content">
               <slot :dataLoading="dataLoading" :pageLoading="pageLoading" />
            </div>
         </transition-group>
      </div>
      <Footer class="footer" />
   </div>
</template>

<script>
import AlertMessages from '@/views/common/widgets/AlertMessages';
import AppHeader from '@/views/common/widgets/AppHeader';
import BreadCrumbs from '@/views/common/widgets/BreadCrumbs';
import Footer from '@/views/common/widgets/Footer';
import SpinnerOverlay from '@/views/common/widgets/SpinnerOverlay';
import PageLoad from './widgets/PageLoad.vue';

export default {
   props: {
      dataLoading: Boolean,
      pageLoading: Boolean,
   },

   components: {
      AlertMessages,
      AppHeader,
      BreadCrumbs,
      Footer,
      SpinnerOverlay,
      PageLoad,
   },
   data() {
      return {
         selectedStudy: '',
      };
   },

   methods: {
      // -------- initialisation on mount --------
      initializeData() {
         // 1. Restore the active study from sessionStorage if present.
         const savedStudy = sessionStorage.getItem('rdigActiveStudy');
         if (savedStudy) {
            this.selectedStudy = JSON.parse(savedStudy);
         }

         // 2. Sync Vuex activeStudy (or fallback to first open study)
         if (this.selectedStudy) {
            this.$store.commit('companies/setActiveStudy', this.selectedStudy);
         }
      },
   },

   mounted() {
      this.initializeData();
   },
};
</script>

<style lang="scss" scoped>
.content-container {
   height: 100%;
   display: flex;
   flex-direction: column;

   .content {
      flex: 1 0 auto;
   }

   .footer {
      flex-shrink: 0;
   }
}

.rdig-click-blocker {
   position: fixed;
   inset: 0; /* top:0; right:0; bottom:0; left:0 */
   z-index: 1099;
   background: transparent;
   pointer-events: auto;
}

.layout-alerts {
   position: fixed;
   left: 50%;
   top: 60px;
   transform: translateX(-50%);
   z-index: 100;
}
</style>
